/** Categorical fills for bar / pie segments; `--ft-chart-*` flip with light/dark in Tailwind. */
export const CHART_PALETTE_FILLS = [
	'var(--ft-chart-1)',
	'var(--ft-chart-2)',
	'var(--ft-chart-3)',
	'var(--ft-chart-4)',
	'var(--ft-chart-5)',
	'var(--ft-chart-6)',
	'var(--ft-chart-7)',
	'var(--ft-chart-8)'
] as const

/** Primary line / area series — steel teal, reads well on white and dark surfaces. */
export const CHART_SERIES_PRIMARY_STROKE = 'var(--ft-chart-5)'

/**
 * Tight analogous ramp (teal / sea / obsidian) for ranked lists like “Top products”.
 * Avoids the full 8-color categorical set so bars feel calmer while staying on-brand.
 */
export const CHART_PALETTE_TOP_PRODUCTS = [
	'var(--ft-chart-5)',
	'var(--ft-chart-7)',
	'var(--ft-scale-seq-3)',
	'var(--ft-scale-seq-4)'
] as const
